import React from "react";
import styled from "@emotion/styled";
import { Color } from "../../utils/color";
import { Link } from "gatsby";

import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs";
import { EnLayout } from "../../components/layout/enLayout";

const EnContactPage = () => {
  return (
    <EnLayout title="CONTACT | LIME" jpUrl="/contact/" enUrl="/en/contact/">
      <Breadcrumbs>
        <Link to="/en/">HOME</Link>
        <span>/</span>
        <Link to="/en/contact/">CONTACT</Link>
        <span>/</span>
      </Breadcrumbs>
      <SSection>
        <p>EN CONTACT</p>
      </SSection>
    </EnLayout>
  );
};

export default EnContactPage;

const SSection = styled.section`
  background-color: ${Color.light};
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
